/** Gemeinsame Welt-Checks — Coach, Bescheide, Tour nutzen dieselbe Logik. */

/** Leitstelle existiert (Flag oder Gebäude auf der Karte). */
export function hasLeitstelleOnMap(s: {
  world: { hasLeitstelle?: boolean; startOrg?: string };
  buildings: Array<{ kind: string }>;
}): boolean {
  return !!s.world.hasLeitstelle || s.buildings.some((b) => b.kind === "leitstelle");
}

/** Erste Einsatzwache der Start-Organisation. */
export function hasStartOrgStation(s: {
  world: { startOrg?: string };
  buildings: Array<{ kind: string }>;
}): boolean {
  const org = s.world.startOrg ?? "fire";
  const kind =
    org === "police" ? "police_station" : org === "ems" ? "ems_station" : "fire_station";
  return s.buildings.some((b) => b.kind === kind);
}
